import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Schema } from 'src/utils/form';

export default Schema.object({
  area: Schema.array().label(''),
  areasSubordinadas: Schema.string().label(''),
  nome: Schema.string().label(<FormattedMessage id="nome" />),
  status: Schema.string().label(<FormattedMessage id="status" />),
  responsaveis: Schema.string().label(''),
  idIntegracao: Schema.string().label(<FormattedMessage id="codigo" />),
  processos: Schema.array().label(''),
  incluirSubprocessos: Schema.boolean().label(''),
  modeloRisco: Schema.string().label(''),
  matrizRisco: Schema.string().label(''),
  tipoRisco: Schema.string().label(''),
  causasRisco: Schema.string().label(''),
  consequenciasRisco: Schema.string().label(''),
  grauRisco: Schema.string().label(''),
});
